import { apiCall } from "./service";
import { URL_PROJECT_DECISION_LOG, URL_PROGRAM_DECISION_LOG, URL_DECISION_LOG } from "./URL";

export const api = {
  sortDecisionLogRequest(params) {
    return apiCall.pagination({
      url: `${URL_PROJECT_DECISION_LOG(params.id)}?pageNumber=${params.page}&pageSize=${params.size}&orderBy=${params.orderBy}`,
      isAuthToken: true,
    });
  },

  getDecisionLogRequest(params) {
    const { parent, search, id, page, size } = params;
    const paginationParams = { pageNumber: page, pageSize: size };
    let url = '';
    switch (parent) {
      case "Project":
        url = URL_PROJECT_DECISION_LOG(params.id);
        break;

      case "Program":
        url = URL_PROGRAM_DECISION_LOG(params.id);
        break;

      default:
        url = '';
        break;
    }

    if (search) {
      paginationParams.searchTerm = search;
    }

    const queryParams = new URLSearchParams(paginationParams).toString();
    const fullUrl = `${url}?${queryParams}`;

    return apiCall.pagination({ url: fullUrl });
  },

  getProgramDecisionLogRequest(params) {
    const { parent, search, id, page, size } = params;
    const paginationParams = { pageNumber: page, pageSize: size };
    let url = URL_PROGRAM_DECISION_LOG(params.id);

    if (search) {
      paginationParams.searchTerm = search;
    }

    const queryParams = new URLSearchParams(paginationParams).toString();
    const fullUrl = `${url}?${queryParams}`;

    return apiCall.pagination({ url: fullUrl });
  },

  fetchSingleDecisionLogRequest(id) {
    return apiCall.get({ url: `${URL_DECISION_LOG}${id}` });
  },

  createDecisionLogRequest(params) {
    return apiCall.post({
      url: `${URL_DECISION_LOG}`,
      isAuthToken: true,
      params: params.payload,
    });
  },

  updateDecisionLogRequest(params) {
    return apiCall.put({
      url: `${URL_DECISION_LOG}${params.id}`,
      isAuthToken: true,
      params: params.payload,
    });
  },

  deleteDecisionLogRequest(params) {
    return apiCall.delete({
      url: `${URL_DECISION_LOG}${params.id}`,
      isAuthToken: true,
      params,
    });
  },

  updateDecisionLogFlagRequest(params) {
    return apiCall.patch({
      url: `${URL_DECISION_LOG}${params.id}`,
      isAuthToken: true,
      params: params.payload,
    });
  },
};

export default api; 